import DailyDelivery from "features/daily-delivery";

const DailyDeliveryPage = () => {
  return <DailyDelivery />;
};

export default DailyDeliveryPage;
